export default "__VITE_ASSET__DIvTN$XZ__"